const normalizeString = (str: string): string => {
	return str
		.toLowerCase()
		.normalize('NFD')
		.replace(/[\u0300-\u036f]/g, '');
};

const calculateSimilarity = (query: string, target: string): number => {
	const normalizedQuery = normalizeString(query);
	const normalizedTarget = normalizeString(target);

	if (normalizedTarget === normalizedQuery) return 100;
	if (normalizedTarget.startsWith(normalizedQuery)) return 80;
	if (normalizedTarget.includes(normalizedQuery)) return 60;

	const words = normalizedTarget.split(/\s+/);
	for (const word of words) {
		if (word.startsWith(normalizedQuery)) return 70;
		if (word.includes(normalizedQuery)) return 50;
	}

	let queryIdx = 0;
	for (let i = 0; i < normalizedTarget.length && queryIdx < normalizedQuery.length; i++) {
		if (normalizedTarget[i] === normalizedQuery[queryIdx]) {
			queryIdx++;
		}
	}
	if (queryIdx === normalizedQuery.length) {
		return 30;
	}

	return 0;
};

export const fuzzyFilter = <T>(
	items: T[],
	query: string,
	getLabel: (item: T) => string
): T[] => {
	if (!query.trim()) return items;

	const scored = items
		.map((item) => ({
			item,
			score: calculateSimilarity(query, getLabel(item)),
		}))
		.filter(({ score }) => score > 0)
		.sort((a, b) => b.score - a.score);

	return scored.map(({ item }) => item);
};
